import { BASE_URL } from "constant";
import privateFetch from "PrivateFetch";

const MODULE_NAME = "MASTER_KODE_TRAYEK";

const ACTION_ADD = "_ADD";
const ACTION_UPDATE = "_UPDATE";
const ACTION_DELETE = "_DELETE";
const ACTION_VIEW = "_VIEW";

const LOADING = "_LOADING";
const ERROR = "_ERROR";
const SUCCESS = "_SUCCESS";

export const VIEW_LOADING = MODULE_NAME + ACTION_VIEW + LOADING;
export const VIEW_ERROR = MODULE_NAME + ACTION_VIEW + ERROR;
export const VIEW_SUCCESS = MODULE_NAME + ACTION_VIEW + SUCCESS;

export const ADD_LOADING = MODULE_NAME + ACTION_ADD + LOADING;
export const ADD_ERROR = MODULE_NAME + ACTION_ADD + ERROR;
export const ADD_SUCCESS = MODULE_NAME + ACTION_ADD + SUCCESS;

export const UPDATE_LOADING = MODULE_NAME + ACTION_UPDATE + LOADING;
export const UPDATE_ERROR = MODULE_NAME + ACTION_UPDATE + ERROR;
export const UPDATE_SUCCESS = MODULE_NAME + ACTION_UPDATE + SUCCESS;

export const DELETE_LOADING = MODULE_NAME + ACTION_DELETE + LOADING;
export const DELETE_ERROR = MODULE_NAME + ACTION_DELETE + ERROR;
export const DELETE_SUCCESS = MODULE_NAME + ACTION_DELETE + SUCCESS;

// ACTION VIEW
const viewLoading = (bool) => {
    return {
        type: VIEW_LOADING,
        loading: bool,
    };
};

const viewError = (bool) => {
    return {
        type: VIEW_ERROR,
        error: bool,
    };
};

const viewSuccess = (bool, payload) => {
    return {
        type: VIEW_SUCCESS,
        success: bool,
        payload: payload,
    };
};

export function viewMasterKodeTrayek(data) {
    let url = BASE_URL + "master_kode_trayek/page";
    return privateFetch(viewSuccess, viewError, viewLoading, "POST", url, data);
}

// ACTION ADD

const addLoading = (bool) => {
    return {
        type: ADD_LOADING,
        loading: bool,
    };
};

const addError = (bool) => {
    return {
        type: ADD_ERROR,
        error: bool,
    };
};

const addSuccess = (bool, payload) => {
    return {
        type: ADD_SUCCESS,
        success: bool,
        payload: payload,
    };
};

export function addMasterKodeTrayek(data) {
    let url = BASE_URL + "master_kode_trayek/save";
    return privateFetch(addSuccess, addError, addLoading, "POST", url, data);
}

// ACTION UPDATE

const updateLoading = (bool) => {
    return {
        type: UPDATE_LOADING,
        loading: bool,
    };
};

const updateError = (bool) => {
    return {
        type: UPDATE_ERROR,
        error: bool,
    };
};

const updateSuccess = (bool, payload) => {
    return {
        type: UPDATE_SUCCESS,
        success: bool,
        payload: payload,
    };
};

export function updateMasterKodeTrayek(data) {
    let url = BASE_URL + "master_kode_trayek/update";
    return privateFetch(updateSuccess, updateError, updateLoading, "POST", url, data);
}

// ACTION UPDATE

const deleteLoading = (bool) => {
    return {
        type: DELETE_LOADING,
        loading: bool,
    };
};

const deleteError = (bool) => {
    return {
        type: DELETE_ERROR,
        error: bool,
    };
};

const deleteSuccess = (bool, payload) => {
    return {
        type: DELETE_SUCCESS,
        success: bool,
        payload: payload,
    };
};

export function deleteMasterKodeTrayek(data) {
    let url = BASE_URL + "master_kode_trayek/delete";
    return privateFetch(deleteSuccess, deleteError, deleteLoading, "POST", url, data);
}
